import { type ReactNode } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { FloatingHover } from '@/components/common/Floating'
import { Icon } from '@/components/icons/Icon'
import { type FloatingPlacementType } from '@/defs/floating'
import { cn } from '@/utils/commonUtil'

import { StatCommonFigure } from '../StatCommonFigure/StatCommonFigure'

import styles from './StatCommonBox.module.scss'

type Props = {
  children?: ReactNode
  height?: 'tall'
  isBlank?: boolean
  isInView?: boolean
  label: ReactNode
  loading?: boolean
  popover?: ReactNode
  popoverPlacement?: FloatingPlacementType
}

export const StatCommonBox = ({
  children,
  height,
  isBlank,
  isInView = true,
  label,
  loading,
  popover,
  popoverPlacement,
}: Props) => {
  const value = isBlank
    ? null
    : (loading ? <Icon name='spinner' /> : children) || <StatCommonFigure>N/A</StatCommonFigure>

  const button = (
    <ButtonRoot className={cn(styles.container, { height, styles })}>
      <span className={styles.value}>{value}</span>
      <span className={styles.label}>{label}</span>
    </ButtonRoot>
  )

  if (!isInView || !popover) return button

  return (
    <FloatingHover content={popover} openDelay={1000} placement={popoverPlacement} styled>
      {button}
    </FloatingHover>
  )
}
